import { ReactNode } from "react";
import { t } from "i18next";

import { I18nKeyType } from "@/i18n";
import { cn } from "@/utils/tailwind.ts";

type SvAnchorProps = {
  href: string;
  className?: string;
} & (
  | {
      i18nKey: I18nKeyType;
      children?: never;
    }
  | {
      i18nKey?: never;
      children?: string | ReactNode | ReactNode[];
    }
);

export const SvAnchor = ({
  href,
  className,
  i18nKey,
  children,
}: SvAnchorProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={cn(
        "text-primary hover:text-primary-700 hover:underline",
        className,
      )}>
      {i18nKey ? t(i18nKey) : children}
    </a>
  );
};
